import { createContext, useState } from 'react';
import {
  ApiCreditCard,
  ApiCreditCardInstalment,
  ApiCreditCardForm,
} from '../api';

export interface CreditCardType {
  creditCard?: ApiCreditCard;
  instalment?: ApiCreditCardInstalment;
  ccValues?: ApiCreditCardForm;
  setCreditCard: (creditCard?: ApiCreditCard) => void;
  setInstalment: (instalment?: ApiCreditCardInstalment) => void;
  setCcValues: (ccValues?: ApiCreditCardForm) => void;
}

const initialCreditCardState: CreditCardType = {
  ccValues: undefined,
  creditCard: undefined,
  instalment: undefined,

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCreditCard: (creditCard?: ApiCreditCard) => {},
  setInstalment: (
    instalment?: ApiCreditCardInstalment,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  ) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCcValues: (ccValues?: ApiCreditCardForm) => {},
};

export const CreditCardContext = createContext<CreditCardType>(
  initialCreditCardState,
);

export default function CreditCardProvider({ children }: any) {
  const [ccValues, setCcValues] = useState<ApiCreditCardForm>();
  const [creditCard, setCreditCard] = useState<ApiCreditCard>();
  const [instalment, setInstalment] = useState<ApiCreditCardInstalment>();

  return (
    <CreditCardContext.Provider
      value={{
        ccValues,
        creditCard,
        instalment,
        setCcValues,
        setCreditCard,
        setInstalment,
      }}
    >
      {children}
    </CreditCardContext.Provider>
  );
}
